module.exports = __webpack_public_path__ + "img/105.italiano.24ac9a49.svg";